import React, { Component } from 'react';
import { connect } from 'react-redux';
import './HomepagePreview.scss';


//icon
import closeIcon from '../../assets/round_close.png';
import { goBack } from 'connected-react-router';

/**
 * Automatic backward to the homescreen, if a pages is navigated to, without a searchterm.
 */
class HomepagePreview extends Component<{ item: any, back: any }, {}> {
  private player: any;

  /**
   * Main render method
   */
  render() {
    console.log(this.props.item);
    return (
      <div className="imagepreview">
        <div className="header">
          <div className="title">{this.props.item.name}</div>
          <div className="navigation">

            <div className="close-container" onClick={() => {
              this.props.back();
            }}>
              <img src={closeIcon} className="closeicon" />
              zurück
              </div>
          </div>
        </div>
        <div className="container">
          <iframe title="homepage" src={this.props.item.url} className="homepage" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    item: state.result.currentItem
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    back() {
      dispatch(goBack());
    }
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HomepagePreview);